import { defineComponent as Q, computed as z, h as o } from "vue";
import { dialogProps as U } from "./ghl-ui.es982.js";
import X from "./ghl-ui.es983.js";
import k from "./ghl-ui.es855.js";
import Y from "./ghl-ui.es854.js";
import { useRtl as Z } from "./ghl-ui.es851.js";
import ee from "./ghl-ui.es984.js";
import { createKey as oe } from "./ghl-ui.es384.js";
import { getMargin as ie } from "./ghl-ui.es856.js";
import { useThemeClass as ne } from "./ghl-ui.es857.js";
import te from "./ghl-ui.es862.js";
import { resolveWrappedSlot as T, resolveSlot as B } from "./ghl-ui.es860.js";
import { render as a } from "./ghl-ui.es985.js";
import M from "./ghl-ui.es253.js";
import le from "./ghl-ui.es859.js";
import N from "./ghl-ui.es865.js";
import se from "./ghl-ui.es866.js";
import re from "./ghl-ui.es864.js";
import ce from "./ghl-ui.es863.js";
const ae = {
  default: () => o(N, null),
  info: () => o(N, null),
  success: () => o(se, null),
  warning: () => o(re, null),
  error: () => o(ce, null)
}, Be = Q({
  name: "Dialog",
  alias: [
    "NimbusConfirmCard",
    // deprecated
    "Confirm"
    // deprecated
  ],
  props: Object.assign(Object.assign({}, k.props), U),
  setup(t) {
    const {
      mergedComponentPropsRef: d,
      mergedClsPrefixRef: c,
      inlineThemeDisabled: u,
      mergedRtlRef: x
    } = Y(t), m = Z("Dialog", x, c), g = z(() => {
      var i, n;
      const {
        iconPlacement: r
      } = t;
      return r || ((n = (i = d == null ? void 0 : d.value) === null || i === void 0 ? void 0 : i.Dialog) === null || n === void 0 ? void 0 : n.iconPlacement) || "left";
    });
    function R(i) {
      const {
        onPositiveClick: n
      } = t;
      n && n(i);
    }
    function f(i) {
      const {
        onNegativeClick: n
      } = t;
      n && n(i);
    }
    function _() {
      const {
        onClose: i
      } = t;
      i && i();
    }
    const h = k("Dialog", "-dialog", X, ee, t, c), v = z(() => {
      const {
        type: i
      } = t, n = g.value, {
        common: {
          cubicBezierEaseInOut: r
        },
        self: {
          fontSize: p,
          lineHeight: C,
          border: e,
          titleTextColor: b,
          textColor: $,
          color: l,
          closeBorderRadius: P,
          closeColorHover: y,
          closeColorPressed: O,
          closeIconColor: S,
          closeIconColorHover: D,
          closeIconColorPressed: E,
          closeIconSize: j,
          borderRadius: H,
          titleFontWeight: w,
          titleFontSize: V,
          padding: W,
          iconSize: F,
          actionSpace: K,
          contentMargin: L,
          closeSize: q,
          [n === "top" ? "iconMarginIconTop" : "iconMargin"]: A,
          [n === "top" ? "closeMarginIconTop" : "closeMargin"]: G,
          [oe("iconColor", i)]: J
        }
      } = h.value, I = ie(A);
      return {
        "--n-font-size": p,
        "--n-icon-color": J,
        "--n-bezier": r,
        "--n-close-margin": G,
        "--n-icon-margin-top": I.top,
        "--n-icon-margin-right": I.right,
        "--n-icon-margin-bottom": I.bottom,
        "--n-icon-margin-left": I.left,
        "--n-icon-size": F,
        "--n-close-size": q,
        "--n-close-icon-size": j,
        "--n-close-border-radius": P,
        "--n-close-color-hover": y,
        "--n-close-color-pressed": O,
        "--n-close-icon-color": S,
        "--n-close-icon-color-hover": D,
        "--n-close-icon-color-pressed": E,
        "--n-color": l,
        "--n-text-color": $,
        "--n-border-radius": H,
        "--n-padding": W,
        "--n-line-height": C,
        "--n-border": e,
        "--n-content-margin": L,
        "--n-title-font-size": V,
        "--n-title-font-weight": w,
        "--n-title-text-color": b,
        "--n-action-space": K
      };
    }), s = u ? ne("dialog", z(() => `${t.type[0]}${g.value[0]}`), v, t) : void 0;
    return {
      mergedClsPrefix: c,
      rtlEnabled: m,
      mergedIconPlacement: g,
      mergedTheme: h,
      handlePositiveClick: R,
      handleNegativeClick: f,
      handleCloseClick: _,
      cssVars: u ? void 0 : v,
      themeClass: s == null ? void 0 : s.themeClass,
      onRender: s == null ? void 0 : s.onRender
    };
  },
  render() {
    var t;
    const {
      bordered: d,
      mergedIconPlacement: c,
      cssVars: u,
      closable: x,
      showIcon: m,
      title: g,
      content: R,
      action: f,
      negativeText: _,
      positiveText: h,
      positiveButtonProps: v,
      negativeButtonProps: s,
      handlePositiveClick: i,
      handleNegativeClick: n,
      mergedTheme: r,
      loading: p,
      type: C,
      mergedClsPrefix: e
    } = this;
    (t = this.onRender) === null || t === void 0 || t.call(this);
    const b = m ? o(te, {
      clsPrefix: e,
      class: `${e}-dialog__icon`
    }, {
      default: () => T(this.$slots.icon, (l) => l || (this.icon ? a(this.icon) : ae[this.type]()))
    }) : null, $ = T(this.$slots.action, (l) => l || h || _ || f ? o("div", {
      class: `${e}-dialog__action`
    }, l || (f ? [a(f)] : [this.negativeText && o(M, Object.assign({
      theme: r.peers.Button,
      themeOverrides: r.peerOverrides.Button,
      ghost: !0,
      size: "small",
      onClick: n
    }, s), {
      default: () => a(this.negativeText)
    }), this.positiveText && o(M, Object.assign({
      theme: r.peers.Button,
      themeOverrides: r.peerOverrides.Button,
      size: "small",
      type: C === "default" ? "primary" : C,
      disabled: p,
      loading: p,
      onClick: i
    }, v), {
      default: () => a(this.positiveText)
    })])) : null);
    return o("div", {
      class: [`${e}-dialog`, this.themeClass, this.closable && `${e}-dialog--closable`, `${e}-dialog--icon-${c}`, d && `${e}-dialog--bordered`, this.rtlEnabled && `${e}-dialog--rtl`],
      style: u,
      role: "dialog"
    }, x ? T(this.$slots.close, (l) => {
      const P = [`${e}-dialog__close`, this.rtlEnabled && `${e}-dialog--rtl`];
      return l ? o("div", {
        class: P
      }, l) : o(le, {
        clsPrefix: e,
        class: P,
        onClick: this.handleCloseClick
      });
    }) : null, m && c === "top" ? o("div", {
      class: `${e}-dialog-icon-container`
    }, b) : null, o("div", {
      class: `${e}-dialog__title`
    }, m && c === "left" ? b : null, B(this.$slots.header, () => [a(g)])), o("div", {
      class: [`${e}-dialog__content`, $ ? "" : `${e}-dialog__content--last`]
    }, B(this.$slots.default, () => [a(R)])), $);
  }
});
export {
  Be as NDialog
};
